"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AWSPinpointProvider_1 = require("./AWSPinpointProvider");
exports.AWSPinpointProvider = AWSPinpointProvider_1.default;
var AWSKinesisProvider_1 = require("./AWSKinesisProvider");
exports.AWSKinesisProvider = AWSKinesisProvider_1.default;
//# sourceMappingURL=index.js.map